module.exports = __webpack_public_path__ + "static/togglplan-7f5ff7e72b5010a14905ad6c2dc80a3a.png";